import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      // Don't redirect if already on auth pages
      if (!window.location.pathname.includes('/login') && !window.location.pathname.includes('/register')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Events
export const getEvents = (params) => api.get('/events', { params });
export const getFeaturedEvents = () => api.get('/events/featured');
export const getEvent = (id) => api.get(`/events/${id}`);
export const createEvent = (data) => api.post('/events', data);
export const updateEvent = (id, data) => api.put(`/events/${id}`, data);
export const submitEvent = (id) => api.post(`/events/${id}/submit`);
export const approveEvent = (id) => api.post(`/events/${id}/approve`);
export const publishEvent = (id) => api.post(`/events/${id}/publish`);

// Categories
export const getCategories = () => api.get('/categories');

// Orders
export const createOrder = (data) => api.post('/orders', data);
export const createGuestOrder = (data) => api.post('/orders/guest', data);
export const getOrders = () => api.get('/orders');
export const getOrder = (id) => api.get(`/orders/${id}`);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`);

// Stripe Payments
export const createPaymentIntent = (orderId, amount) => api.post('/payments/create-intent', { order_id: orderId, amount });
export const confirmPayment = (orderId, paymentIntentId) => api.post('/payments/confirm', null, { params: { order_id: orderId, payment_intent_id: paymentIntentId } });
export const processTestPayment = (orderId, cardNumber) => api.post('/payments/test', { order_id: orderId, card_number: cardNumber });

// File Upload
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Tickets
export const getTickets = () => api.get('/tickets');
export const getTicket = (id) => api.get(`/tickets/${id}`);
export const validateTicket = (ticketId) => api.post('/tickets/validate', { ticket_id: ticketId });

// Organizer
export const getOrganizerEvents = () => api.get('/organizer/events');
export const getOrganizerAnalytics = () => api.get('/organizer/analytics');
export const getOrganizerStats = () => api.get('/organizer/stats');
export const getOrganizerMessages = () => api.get('/organizer/messages');
export const markMessageRead = (messageId) => api.put(`/organizer/messages/${messageId}/read`);

// Contact
export const sendContactMessage = (eventId, data) => api.post(`/events/${eventId}/contact`, data);

// Admin
export const getAdminEvents = (params) => api.get('/admin/events', { params });
export const getAdminUsers = () => api.get('/admin/users');
export const updateUserRole = (userId, role) => api.put(`/admin/users/${userId}/role`, null, { params: { role } });
export const getAdminAnalytics = () => api.get('/admin/analytics');

export default api;
